import React from 'react';
import { VenueFlags } from 'core/entities';
import { dateFormats, getSimpleFormatDate } from 'utils/date/date';
import { FlaggedVenueIndicatorProps } from 'ui-components/venue-status-indicator/venue-status-indicator';
import { TooltipIcon } from '@placer-ui/components';

const fallbackText = 'Reports for limited data venues are not supported';
export const venueFlagInfo: Record<VenueFlags, string> = {
    indoor: 'The venue is located entirely inside a larger enclosed structure, and therefore is not available',
    multi_story:
        'This venue is located in a multistory building, with other tenants above/below, ' +
        'and therefore is not available',
    unusual_visit_volume: 'Reports for venues with visits abnormalities are not supported',
    dense_area:
        'The location is in a highly dense area with a large number of venues in close proximity, and therefore ' +
        'is not available',
    privacy_concerns: 'Reports for sensitive venues are not supported. Contact support for access',
    privacy_policy: 'Reports for sensitive venues are not supported. Contact support for access',
    unknown_flag: fallbackText,
    nearby_activity: fallbackText,
    not_available: fallbackText,
    low_panel: '',
};

export const VenueStatusIndicatorV1 = ({
    flag,
    closingDate,
    custom,
}: FlaggedVenueIndicatorProps) => {
    if (!flag && !closingDate && !custom) {
        return null;
    }

    let tooltipText;
    if (flag) {
        tooltipText = venueFlagInfo[flag];
    } else if (closingDate) {
        tooltipText = `Closed - Data available until ${getSimpleFormatDate(
            closingDate!,
            dateFormats.shortMonthYearWithNumericOrdinalContractionDayComma,
        )}`;
    }

    if (custom) {
        if (tooltipText) {
            tooltipText = `${tooltipText}. ${custom}`;
        } else {
            tooltipText = custom;
        }
    }

    return (
        <TooltipIcon
            title={tooltipText}
            testId="venue-status-indicator"
            iconProps={{
                type: 'Warning',
            }}
            tooltipProps={{
                appendToParent: true,
                placement: 'top',
                maxWidth: 250,
                testId: 'venue-status-indicator',
            }}
        />
    );
};
